export const CardSkeleton = () => {
  return (
    <div className="rounded-lg bg-white mx-2 sm:mx-3 md:mx-5 mb-4 sm:mb-5 border shadow relative animate-pulse">
      {/* Top section */}
      <div className="p-3 sm:p-4 md:pt-5 md:px-5 md:pb-2 border-b flex flex-col">
        {/* Phase */}
        <div className="bg-gray-200 h-3 sm:h-4 w-20 sm:w-24 rounded"></div>
        {/* Title */}
        <div className="bg-gray-200 h-5 sm:h-6 w-full mt-2 rounded"></div>
        {/* Authority */}
        <div className="flex items-center w-full pt-1">
          <div className="bg-gray-200 h-4 sm:h-5 w-4 sm:w-5 rounded-full flex-shrink-0"></div>
          <div className="bg-gray-200 h-3 sm:h-4 w-3/4 ml-1 rounded"></div>
        </div>
      </div>

      {/* Bottom section */}
      <div className="p-3 sm:p-4 md:px-5 md:pb-5 md:pt-2 flex flex-col md:flex-row w-full">
        {/* Description */}
        <div className="w-full md:w-[65%] md:pr-5 flex border-b md:border-r md:border-b-0 pb-3 md:pb-0">
          <div className="flex flex-col w-full">
            <div className="bg-gray-200 h-3 sm:h-4 w-full rounded mb-2"></div>
            <div className="bg-gray-200 h-3 sm:h-4 w-full rounded mb-2"></div>
            <div className="bg-gray-200 h-3 sm:h-4 w-full rounded mb-2"></div>
            <div className="bg-gray-200 h-3 sm:h-4 w-3/4 rounded"></div>
          </div>
        </div>

        {/* Details */}
        <div className="flex flex-col w-full md:w-[35%] pt-3 md:pt-0 md:pl-5">
          {/* Publication date */}
          <div className="flex justify-between mb-1 sm:mb-2">
            <div className="flex items-center">
              <div className="bg-gray-200 h-3 sm:h-4 w-3 sm:w-4 rounded-full flex-shrink-0"></div>
              <div className="bg-gray-200 h-3 sm:h-4 w-20 sm:w-24 ml-1 rounded"></div>
            </div>
            <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-20 rounded"></div>
          </div>

          {/* Closing date */}
          <div className="flex justify-between mb-1 sm:mb-2">
            <div className="flex items-center">
              <div className="bg-gray-200 h-3 sm:h-4 w-3 sm:w-4 rounded-full flex-shrink-0"></div>
              <div className="bg-gray-200 h-3 sm:h-4 w-20 sm:w-24 ml-1 rounded"></div>
            </div>
            <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-20 rounded"></div>
          </div>

          {/* Procedure */}
          <div className="flex justify-between mb-1 sm:mb-2">
            <div className="flex items-center">
              <div className="bg-gray-200 h-3 sm:h-4 w-3 sm:w-4 rounded-full flex-shrink-0"></div>
              <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-20 ml-1 rounded"></div>
            </div>
            <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-20 rounded"></div>
          </div>

          {/* Type */}
          <div className="flex justify-between">
            <div className="flex items-center">
              <div className="bg-gray-200 h-3 sm:h-4 w-3 sm:w-4 rounded-full flex-shrink-0"></div>
              <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-24 ml-1 rounded"></div>
            </div>
            <div className="bg-gray-200 h-3 sm:h-4 w-16 sm:w-20 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
